var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer-page"},[_c('firm-info',{attrs:{"formInfo":_vm.form}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }